import { clearAllLocalData } from "@/lib/offline";
import { logWarn } from "@/lib/log";

// Full device purge on logout: no tenant data, drafts, queued forms or cached
// responses may survive for the next user of this device.
export async function purgeDeviceData() {
  await clearAllLocalData();
  if ("caches" in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch (e) {
      logWarn("deviceCleanup: cache purge failed (SW will refresh on next load)", e);
    }
  }
}
